import React, { useCallback, useEffect, useMemo, useState } from "react";

import { Button } from "reactstrap";

import ProfileDropdown from "../Components/Common/ProfileDropdown";

import {
  changeSidebarVisibility,
  getBillings,
  leaveImpersonate,
} from "../slices/thunks";
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import { useNavigate } from "react-router-dom";
import Icon from "Components/Icons/Icon";
import CustomFormModal, { Field } from "Components/Modals/CustomFormModal";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useAppSelector } from "Components/Hooks/hooks";
import { submitSupportTicketApi } from "helpers/ApiManager";
import { ErrorHandler, ErrorToast, SuccessToast } from "utils/toast";
import { SupportTicketArgs } from "types/auth.api";
import FullScreenLoader from "Components/Common/FullScreenLoader";
import { formatDateToReadable } from "utils/formatDates";
import {
  VALIDATION_LIMITS,
  VALIDATION_MESSAGES,
  createDescriptionValidation,
} from "Components/constants/validation";
import { getPurchases, PRODUCT_ID } from "helpers/purchases";
import DeleteItemModal from "Components/Modals/DeleteItemModal";
import { setRevenueBillingInfo } from "slices/auth/reducer";

const Header = ({ headerClass }: any) => {
  const dispatch: any = useDispatch();
  const navigate = useNavigate();
  const [supportModal, setSupportModal] = React.useState(false);
  const configData = useAppSelector((state) => state.config.configData);
  const { user, isImpersonated, revenueBillingInfo } = useAppSelector(
    (state) => state.auth,
  );
  const bilingInvoices = useAppSelector((s) => s.billing.bilingInvoices);
  const customerInfo = revenueBillingInfo?.info;
  const willRenew = revenueBillingInfo?.willRenew;
  const role = user?.role;
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [showRenewModal, setShowRenewModal] = useState<boolean>(false);
  // const [isCancelling, setIsCancelling] = useState<boolean>(false);
  const [showCancelModal, setShowCancelModal] = useState<boolean>(false);

  const selectDashboardData = createSelector(
    (state) => state.Layout,
    (sidebarVisibilitytype) => sidebarVisibilitytype.sidebarVisibilitytype,
  );
  // Inside your component
  const sidebarVisibilitytype = useSelector(selectDashboardData);

  useEffect(() => {
    try {
      dispatch(getBillings({}));
    } catch (error) {}
  }, []);

  const toogleMenuBtn = () => {
    var windowSize = document.documentElement.clientWidth;
    const humberIcon = document.querySelector(".hamburger-icon") as HTMLElement;
    dispatch(changeSidebarVisibility("show"));

    if (windowSize > 767) humberIcon.classList.toggle("open");

    //For collapse horizontal menu
    if (document.documentElement.getAttribute("data-layout") === "horizontal") {
      document.body.classList.contains("menu")
        ? document.body.classList.remove("menu")
        : document.body.classList.add("menu");
    }

    //For collapse vertical and semibox menu
    if (
      sidebarVisibilitytype === "show" &&
      (document.documentElement.getAttribute("data-layout") === "vertical" ||
        document.documentElement.getAttribute("data-layout") === "semibox")
    ) {
      if (windowSize < 1025 && windowSize > 767) {
        document.body.classList.remove("vertical-sidebar-enable");
        document.documentElement.getAttribute("data-sidebar-size") === "sm"
          ? document.documentElement.setAttribute("data-sidebar-size", "")
          : document.documentElement.setAttribute("data-sidebar-size", "sm");
      } else if (windowSize > 1025) {
        document.body.classList.remove("vertical-sidebar-enable");
        document.documentElement.getAttribute("data-sidebar-size") === "lg"
          ? document.documentElement.setAttribute("data-sidebar-size", "sm")
          : document.documentElement.setAttribute("data-sidebar-size", "lg");
      } else if (windowSize <= 767) {
        document.body.classList.add("vertical-sidebar-enable");
        document.documentElement.setAttribute("data-sidebar-size", "lg");
      }
    }

    //Two column menu
    if (document.documentElement.getAttribute("data-layout") === "twocolumn") {
      document.body.classList.contains("twocolumn-panel")
        ? document.body.classList.remove("twocolumn-panel")
        : document.body.classList.add("twocolumn-panel");
    }
  };

  useEffect(() => {
    const getPurchaseInfo = async () => {
      if (!user?.company?.id) {
        return;
      }
      try {
        const purchases = getPurchases(user.company.id.toString());
        const info = await purchases.getCustomerInfo();
        console.log("Fetched Customer Info:", info);

        dispatch(
          setRevenueBillingInfo({
            info: info,
            willRenew:
              info.subscriptionsByProductIdentifier[PRODUCT_ID]?.willRenew ||
              false,
          }),
        );
      } catch (error) {
        console.log("Error fetching purchase info:", error);
      }
    };

    getPurchaseInfo();
  }, [dispatch, user?.company?.id]);

  const handleConfirmCancel = async () => {
    if (!user?.company?.id) {
      return;
    }

    setShowCancelModal(false);
    // setIsCancelling(true);
    try {
      const sub = customerInfo?.subscriptionsByProductIdentifier[PRODUCT_ID];

      if (sub?.store !== "rc_billing" && sub?.store !== "stripe") {
        ErrorToast("Cannot manage subscription: Store mismatch");
        return;
      }

      console.log("Cancel Plan Pressed", customerInfo);

      // Open the management URL where user can cancel
      if (customerInfo?.managementURL) {
        window.open(customerInfo.managementURL, "_blank");
      } else {
        ErrorToast("Unable to open subscription management. Please try again.");
      }
    } catch (error) {
      console.error("Error fetching subscription info:", error);
      ErrorToast("Failed to load subscription details. Please try again.");
    } finally {
      // setIsCancelling(false);
    }
  };

  const submitSupportTicket = async () => {
    try {
      let passedData: SupportTicketArgs = {
        support_ticket_area_id: validation.values.area,
        description: validation.values.desc?.trim(),
      };
      if (validation.values.beSpecific) {
        passedData = {
          support_ticket_area_id: validation.values.area,
          other_area: validation.values.beSpecific?.trim(),
          description: validation.values.desc?.trim(),
        };
      }

      let res = await submitSupportTicketApi(passedData);
      if (res.result) {
        SuccessToast("Support ticket submitted successfully");
      }
    } catch (error) {
      ErrorHandler(error);
      console.log("Error submitting support ticket:", error);
    }
  };

  const validation = useFormik<{
    area: number;
    beSpecific: string;
    desc: string;
  }>({
    enableReinitialize: true,
    initialValues: {
      area: 0,
      beSpecific: "",
      desc: "",
    },
    validationSchema: Yup.object({
      area: Yup.number()
        .min(1, "Area is required")
        .required("Area is required"),

      beSpecific: Yup.string()
        .trim()
        .when("area", (value, schema) => {
          const area = Number(value);
          return area === 6
            ? schema
                .required(VALIDATION_MESSAGES.REQUIRED("This field"))
                .min(
                  VALIDATION_LIMITS.NAME.MIN,
                  VALIDATION_MESSAGES.MIN_LENGTH(
                    "This field",
                    VALIDATION_LIMITS.NAME.MIN,
                  ),
                )
            : schema.notRequired();
        }),

      desc: Yup.string()
        .trim()
        .required(VALIDATION_MESSAGES.REQUIRED("Description"))
        .min(
          VALIDATION_LIMITS.DESCRIPTION.MIN,
          VALIDATION_MESSAGES.MIN_LENGTH(
            "Description",
            VALIDATION_LIMITS.DESCRIPTION.MIN,
          ),
        )
        .max(
          VALIDATION_LIMITS.DESCRIPTION.MAX,
          VALIDATION_MESSAGES.MAX_LENGTH(
            "Description",
            VALIDATION_LIMITS.DESCRIPTION.MAX,
          ),
        )
        .test(
          "valid-description",
          createDescriptionValidation("Description").message,
          createDescriptionValidation("Description").test,
        ),
    }),
    onSubmit: (values) => {
      console.log("Support form submitted:", values);
      // TODO: Add your API call here to submit support ticket
      // dispatch(submitSupportTicket(values));
      submitSupportTicket();
      // Close modal after submission
      setSupportModal(false);
      validation.resetForm();
    },
  });

  let supportFields: Field[] = useMemo(
    () => [
      {
        name: "area",
        label: "Area",
        type: "select",
        placeholder: "Select area",
        options: (configData?.support_ticket_areas || []).map((area) => ({
          label: area.description,
          value: area.id,
        })),
      },
      // Insert only when area === 6
      ...(validation.values.area === 6
        ? [
            {
              name: "beSpecific",
              label: "Be Specific",
              type: "text",
              placeholder: "Be Specific",
            } as Field,
          ]
        : []),
      {
        name: "desc",
        label: "Description",
        type: "textarea",
        placeholder: "Description",
      },
    ],

    [configData, validation.values.area],
  );

  const handleLeaveImpersonate = useCallback(async () => {
    try {
      setIsLoading(true);
      await dispatch(leaveImpersonate())?.unwrap();
      navigate("/dashboard", { replace: true });
    } catch (error) {
      console.error("Error leaving impersonation:", error);
      ErrorHandler(error);
    } finally {
      setIsLoading(false);
    }
  }, [dispatch, navigate]);

  const handleSubscription = () => {
    navigate("/subscribe-plan");
  };

  const onCancelSubscription = () => {
    if (!user?.company?.id) {
      return;
    }
    if (willRenew) {
      setShowCancelModal(true);
    } else {
      setShowRenewModal(true);
    }
  };

  const onTeamMemberClick = () => {
    ErrorToast(
      "Only the account owner can manage subscriptions. Please contact your owner.",
    );
  };

  return (
    <React.Fragment>
      <FullScreenLoader
        isLoading={isLoading}
        message="Switching to admin account..."
      />
      <header id="page-topbar" className={headerClass}>
        <div className="layout-width ">
          <div className="navbar-header">
            <div className="d-flex">
              <button
                onClick={toogleMenuBtn}
                type="button"
                className=" btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger d-block d-md-none"
                id="topnav-hamburger-icon"
              >
                <span className="hamburger-icon">
                  <span></span>
                  <span></span>
                  <span></span>
                </span>
              </button>
              {role === "user" &&
                (user?.is_trial_period ? (
                  <div className="d-flex align-items-center gap-3 px-3 py-3  rounded ">
                    <span className="text-nowrap text-grey89 fs-16 fw-normal">
                      Free trial ends on{" "}
                      {formatDateToReadable(user?.subscription_ended_at || "")}
                    </span>

                    <Button
                      className="d-flex align-items-center gap-2 br-7 fs-16"
                      style={{
                        background:
                          "linear-gradient(270deg, #082B60 0%, #000000 100%)",
                      }}
                      onClick={() => {
                        if (user?.is_team_member) {
                          onTeamMemberClick();
                        } else {
                          handleSubscription();
                        }
                      }}
                    >
                      <span className="text-white fs-14 fw-normal font-primary">
                        Subscribe
                      </span>
                      <i
                        className="bx bx-chevron-right me-0 pe-0"
                        style={{ fontSize: 20 }}
                      />
                    </Button>
                  </div>
                ) : (
                  !user?.is_subscription_active && (
                    <div className="d-flex align-items-center gap-3 px-3 py-3  rounded ">
                      <span className="text-nowrap text-grey89 fs-16 fw-normal">
                        {/* {"Your subscription ended on"}{" "}
                        {formatDateToReadable(
                          user?.subscription_ended_at || "",
                        )} */}
                        {bilingInvoices.length === 0
                          ? "Get the Pro plan to enjoy all premium features."
                          : "Your subscription has expired."}
                      </span>

                      <Button
                        className="d-flex align-items-center gap-2 br-7 fs-16"
                        style={{
                          background:
                            "linear-gradient(270deg, #082B60 0%, #000000 100%)",
                        }}
                        onClick={
                          user?.is_team_member
                            ? onTeamMemberClick
                            : user?.is_subscription_active
                            ? onCancelSubscription
                            : handleSubscription
                        }
                      >
                        <span className="text-white fs-14 fw-normal font-primary">
                          {!user?.is_subscription_active &&
                          bilingInvoices.length === 0
                            ? "Subscribe"
                            : "Manage Subscription & Billing"}
                        </span>
                        <i
                          className="bx bx-chevron-right me-0 pe-0"
                          style={{ fontSize: 20 }}
                        />{" "}
                      </Button>
                    </div>
                  )
                ))}
            </div>

            <div className="d-flex align-items-center">
              {role === "user" && (
                <>
                  {isImpersonated && (
                    <Button
                      className="d-flex gap-2 br-7 fs-16 bg-danger border-0 me-5"
                      onClick={handleLeaveImpersonate}
                    >
                      <span className="text-white fs-14 fw-normal font-primary">
                        Leave Impersonate
                      </span>
                      <i
                        className="bx bx-chevron-right me-0 pe-0"
                        style={{ fontSize: 20 }}
                      />
                    </Button>
                  )}
                  {/* need help Or Assistant */}
                  <button
                    className="border-0 d-flex align-items-center justify-content-center me-2 bg-white btn-press-effect"
                    onClick={() => {
                      setSupportModal(true);
                    }}
                  >
                    <Icon name="Help" />
                  </button>
                  <button
                    className="border-0 d-flex align-items-center justify-content-center me-2 bg-white btn-press-effect"
                    onClick={() => {
                      navigate("/notifications-list");
                    }}
                  >
                    <Icon name="Notify" />
                  </button>
                </>
              )}

              {/* ProfileDropdown */}
              <ProfileDropdown />
              <CustomFormModal
                isOpen={supportModal}
                onCancel={() => {
                  setSupportModal(false);
                }}
                fields={supportFields}
                title={"Support"}
                submitText="Submit"
                validation={validation}
                isLoading={validation.isSubmitting}
              />
            </div>
          </div>
        </div>
      </header>
      <DeleteItemModal
        show={showRenewModal}
        onCloseClick={() => setShowRenewModal(false)}
        onDeleteClick={handleConfirmCancel}
        title="Renew Subscription"
        description="Do you want to continue your subscription?"
        confirmText="Renew Now"
        icon={<Icon name="SubscriptionRequired" fontSize={80} />}
      />

      <DeleteItemModal
        show={showCancelModal}
        onCloseClick={() => setShowCancelModal(false)}
        onDeleteClick={handleConfirmCancel}
        title="Cancel Subscription"
        description="Are you sure you want to cancel your subscription?"
        confirmText="Yes, Cancel"
        icon={<i className="ri-close-circle-line display-5 text-danger"></i>}
      />
    </React.Fragment>
  );
};

export default Header;
